module.exports = __webpack_public_path__ + "img/logo.a9d6b60f.png";